import { collection, doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

export class ApiUsageService {
  private static API_USAGE_COLLECTION = 'apiUsageLogs';

  static async logApiCall(
    provider: 'twelveData' | 'alphaVantage',
    endpoint: string,
    symbols: string[],
    credits: number = 1
  ): Promise<void> {
    try {
      const docRef = doc(collection(db, this.API_USAGE_COLLECTION));
      await setDoc(docRef, {
        provider,
        endpoint,
        symbols,
        symbolCount: symbols.length,
        credits,
        timestamp: serverTimestamp(),
      });
    } catch (error) {
      console.error('Error logging API usage:', error);
      // Don't throw - we don't want API logging failures to break the app
    }
  }

  static async logTwelveDataCall(symbols: string[]): Promise<void> {
    // Twelve Data batch requests count as 1 credit for up to 120 symbols
    const credits = Math.ceil(symbols.length / 120);
    await this.logApiCall('twelveData', 'quote', symbols, credits);
  }

  static async logAlphaVantageCall(symbol: string): Promise<void> {
    // Alpha Vantage charges 1 request per symbol
    await this.logApiCall('alphaVantage', 'quote', [symbol], 1);
  }
}